import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";

import { ErrorPage } from "@/components/ErrorPage";
import { PageHeader } from "@/components/PageHeader";
import { useLoggedInSession } from "@/session";
import { toError } from "@/lib/utils";

export const Route = createFileRoute("/portal")({
  component: RouteComponent,
  errorComponent: ({ error }) => <ErrorPage message={toError(error).message} />,
});

function RouteComponent() {
  const { session } = useLoggedInSession();

  if (!session.verified) {
    return <Navigate to="/fillout" />;
  }

  return (
    <div>
      <PageHeader />
      <Outlet />
    </div>
  );
}
